// extracted by mini-css-extract-plugin
export default {"price":"Price_price__WkAq7","inner":"Price_inner__IDDoS","best__option":"Price_best__option__IpNON","best__option-price":"Price_best__option-price__c60V6"};